export enum EIntegrationName {
  AuthorizeNet = 'authorizenet',
  LimeCRM = 'limecrm',
  Closeio = 'closeio',
  Freshsales = 'freshsales',
  Freshworks = 'freshworks',
  SAMLAuthentication = 'saml',
  HubspotMarketing = 'hubspotmarketing',
  Stripe = 'stripe',
  Sympa = 'sympa',
  Pardot = 'pardot',
  SCIM = 'scim',
  Pipedrive = 'pipedrive',
  CustomConversion = 'conversion',
  EmailDocumentImport = 'email',
  Upsales = 'upsales',
  Zapier = 'zapier',
}
